module.exports = __webpack_public_path__ + "img/freespin_reel.7bd3fbce.png";